import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

import { loadAccountUsers } from '../action/user/load-account-users';
import { usersForAccountIdSelector } from '../reducers/user-selectors';

const mapStateToProps = (state: any, { accountId }: InputProps) => ({
  users: usersForAccountIdSelector(state, accountId).filter((u) => u.isActive),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { accountId }: InputProps,
) => ({
  actions: {
    loadAccountUsers: () => dispatch(loadAccountUsers(accountId)),
  },
});

type InputProps = {
  accountId: number;
  onSelectedUsersChange: (users: User[]) => void;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const UsersPicker = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ actions, users, onSelectedUsersChange }: Props) => {
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);

  useEffect(() => {
    actions.loadAccountUsers();
  });

  const handleChange =
    (user: User) => (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const selected = checked
        ? selectedUsers.concat([user])
        : selectedUsers.filter((u) => u.username !== user.username);
      setSelectedUsers(selected);
      onSelectedUsersChange(selected);
    };

  if (!users) {
    return null;
  }

  return (
    <FormGroup>
      {users.map((user) => {
        const name = `${user.firstName} ${user.lastName}`;
        return (
          <FormControlLabel
            key={`${user.username}-${user.firstName}`}
            control={
              <Checkbox
                checked={selectedUsers.includes(user)}
                onChange={handleChange(user)}
                name={name}
              />
            }
            label={name}
          />
        );
      })}
    </FormGroup>
  );
});
